import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './NavigationLinks.css';
import { navigationLinks, fatNavigationLinks } from '../../../constants/navigation';
import { trackAnchorTabClick } from '../../../tracking';
import { TNavigationLinkType } from '../../../types';
import { scrollToElement } from '../helpers';

interface INavigationLinksProps extends React.HTMLProps<HTMLAnchorElement> {
  links: TNavigationLinkType[];
  activeLink?: TNavigationLinkType;
  isFat?: boolean;
}

export function NavigationLinks(params: INavigationLinksProps) {
  const {
    links,
    activeLink,
    className,
    isFat,
    /* tslint:disable-next-line:trailing-comma */
    ...props
  } = params;
  const navLinks = isFat ? fatNavigationLinks : navigationLinks;

  return (
    <>
      {navLinks
        .filter(link => links.includes(link.name))
        .map(link => (
          <a
            {...props}
            href={`#${link.name}`}
            {...mergeStyles(styles['link'], activeLink === link.name && styles['link--active'], className)}
            key={link.name}
            onClick={event => {
              event.preventDefault();

              scrollToElement(document.querySelector(`#${link.name}`));
              trackAnchorTabClick(link.name);
            }}
          >
            {link.label}
          </a>
        ))}
    </>
  );
}
